import { useState, useEffect } from 'react';
import { consultasService as consultaService } from '../services/api';

export default function SistemaNotificacoes() {
  const [notificacoes, setNotificacoes] = useState<any[]>([]);
  const [erro, setErro] = useState<boolean>(false);

  useEffect(() => {
    const verificarNotificacoes = async () => {
      try {
        setErro(false);
        const consultas = await consultaService.listarTodas();
        
        if (!Array.isArray(consultas)) {
          console.error('Formato inválido de consultas:', consultas);
          setNotificacoes([]);
          setErro(true);
          return;
        }
        
        const hoje = new Date();
        const amanha = new Date();
        amanha.setDate(hoje.getDate() + 1);
        
        const proximas = consultas
          .filter(c => {
            try {
              if (!c || !c.data) return false;
              
              const dataConsulta = new Date(c.data);
              const diff = Math.floor((dataConsulta.getTime() - hoje.getTime()) / (1000 * 3600 * 24));
              return !isNaN(diff) && diff >= 0 && diff <= 3 && !c.realizada;
            } catch (err) {
              console.error('Erro ao processar consulta:', err);
              return false;
            }
          })
          .map(c => ({
            id: c.id,
            mensagem: `Consulta em ${formatarData(c.data)} às ${c.hora}`
          }));
        
        setNotificacoes(Array.isArray(proximas) ? proximas : []);
      } catch (error) {
        console.error('Erro ao verificar notificações:', error);
        setNotificacoes([]);
        setErro(true);
      }
    };
    
    verificarNotificacoes();
    
    // Verificar a cada 5 minutos
    const intervalo = setInterval(verificarNotificacoes, 5 * 60 * 1000);
    return () => clearInterval(intervalo);
  }, []);
  
  const formatarData = (data: string) => {
    if (!data) return '';
    try {
      const [ano, mes, dia] = data.split('-');
      return `${dia}/${mes}/${ano}`;
    } catch (err) {
      return data;
    }
  };
  
  if (erro) {
    return null; // Não mostrar o componente em caso de erro
  }
  
  return (
    <div className="dropdown">
      <button className="btn btn-sm btn-light position-relative" type="button" data-bs-toggle="dropdown">
        <i className="bi bi-bell"></i>
        {notificacoes.length > 0 && (
          <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
            {notificacoes.length}
          </span>
        )}
      </button>
      
      <ul className="dropdown-menu dropdown-menu-end">
        {Array.isArray(notificacoes) && notificacoes.length === 0 ? (
          <li><span className="dropdown-item text-muted">Sem notificações</span></li>
        ) : (
          Array.isArray(notificacoes) && notificacoes.map(notificacao => (
            <li key={notificacao.id}>
              <span className="dropdown-item">{notificacao.mensagem}</span>
            </li>
          ))
        )}
      </ul>
    </div>
  );
}
